import React, { FC } from "react";
import { SkeletonListMultiLine } from "../../Skeleton/SkeletonListMultiLine";
import { SkeletonListKeyValue } from "../../Skeleton/SkeletonListKeyValue";
import useUserAgent from "../../../../hooks/useUserAgent";
import styles from "./FlightsContentSkeleton.module.css";
import { mcn } from "../../../../utils/mergeClassnames";

const FlightsContentSkeleton: FC = () => {
  const { isMobile } = useUserAgent();

  return (
    <div className={mcn(isMobile && styles.skeletonWrapper)}>
      <div className={isMobile ? styles.skeletonSpacer : styles.skeletonSpacerDesktop}>
        <SkeletonListKeyValue amount={4} />
      </div>
      <div className={isMobile ? styles.skeletonSpacer : styles.skeletonSpacerDesktop}>
        <SkeletonListKeyValue amount={4} />
      </div>
      <div className={isMobile ? styles.skeletonSpacer : styles.skeletonMarginDesktop}>
        <SkeletonListMultiLine amount={2} />
      </div>
    </div>
  );
};
export default FlightsContentSkeleton;
